import { render, staticRenderFns } from "./school-type.vue?vue&type=template&id=30dead62&scoped=true"
import script from "./school-type.vue?vue&type=script&lang=js"
export * from "./school-type.vue?vue&type=script&lang=js"
import style0 from "./school-type.vue?vue&type=style&index=0&id=30dead62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dead62",
  null
  
)

export default component.exports